import { Builder } from '@builder.io/react';

import Events from './index';

Builder.registerComponent(Events, {
  name: 'Events',
  inputs: [
    {
      name: 'tabs',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'events',
          type: 'list',
          subFields: [
            { name: 'overtitle', type: 'string' },
            { name: 'title', type: 'string' },
            { name: 'subtitle', type: 'string' },
            { name: 'href', type: 'string' },
            {
              name: 'image',
              type: 'object',
              subFields: [
                { name: 'src', type: 'file', allowedFileTypes: ['jpg', 'png'] },
                { name: 'alt', type: 'string' },
              ]
            }
          ]
        }
      ]
    }
  ]
});
